// reducers/reviewReducer.js
import {
  FETCH_REVIEWS_REQUEST,
  FETCH_REVIEWS_SUCCESS,
  FETCH_REVIEWS_FAILURE,
} from "../actions/types";

const initialState = {
  reviews: [],
  pagination: { page: 1, size: 50, total: 0, pages: 1 },
  loading: false,
  error: null,
  message: "",
};

export default function reviewReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_REVIEWS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        message: "",
      };

    case FETCH_REVIEWS_SUCCESS: {
      const items = Array.isArray(action.payload?.items) ? action.payload.items : [];
      const pagination = action.payload?.pagination || state.pagination;

      return {
        ...state,
        loading: false,
        reviews: items,
        pagination,
        error: null,
        message: "Reviews loaded successfully",
      };
    }

    case FETCH_REVIEWS_FAILURE:
      return {
        ...state,
        loading: false,
        reviews: [],
        pagination: { page: 1, size: 50, total: 0, pages: 1 },
        error: action.payload || "Failed to fetch reviews",
        message: "",
      };

    default:
      return state;
  }
}
